"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visitValue = void 0;
const exception_1 = require("../exception");
const visitValue = (visitor, value, arg) => {
    switch (value.type) {
        case "Boolean":
            return visitor.visitBoolean(value, arg);
        case "Date":
            return visitor.visitDate(value, arg);
        case "Month":
            return visitor.visitMonth(value, arg);
        case "Number":
            return visitor.visitNumber(value, arg);
        case "Quote":
            return visitor.visitQuote(value, arg);
        case "Record":
            return visitor.visitRecord(value, arg);
        case "String":
            return visitor.visitString(value, arg);
        case "Time":
            return visitor.visitTime(value, arg);
        case "Vector":
            return visitor.visitVector(value, arg);
        case "Weekday":
            return visitor.visitWeekday(value, arg);
    }
    throw new exception_1.LaskinError(`Unrecognized value type: ${value.type}`);
};
exports.visitValue = visitValue;
